module.exports = __webpack_public_path__ + "img/anggota-dark.7b1c4376.svg";